/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useState } from "react";

import type { ReactNode } from "react";

export interface U2000BusyIndicatorContextType {
  isLoading: boolean;
  showBusyIndicator: () => void;
  hideBusyIndicator: () => void;
}

const U2000BusyIndicatorContext = createContext<U2000BusyIndicatorContextType | undefined>(undefined);

interface U2000BusyIndicatorProviderProps {
  children: ReactNode;
}

export const U2000BusyIndicatorProvider = ({ children }: U2000BusyIndicatorProviderProps) => {
  const [isLoading, setLoading] = useState<boolean>(false);

  const showBusyIndicator = (): void => {
    setLoading(true);
  };

  const hideBusyIndicator = (): void => {
    setLoading(false);
  };

  const contextValue: U2000BusyIndicatorContextType = {
    isLoading,
    showBusyIndicator,
    hideBusyIndicator,
  };

  return <U2000BusyIndicatorContext.Provider value={contextValue}>{children}</U2000BusyIndicatorContext.Provider>;
};

export function useU2000BusyIndicatorContext(): U2000BusyIndicatorContextType {
  const context = useContext(U2000BusyIndicatorContext);

  if (!context) {
    throw new Error("useU2000BusyIndicatorContext must be used within a U2000BusyIndicatorProvider");
  }
  return context;
}
